import { FC } from 'react';
import { Avatar, AvatarGroup, Box } from '@mui/material';
import { ShortCommunityPerkDto } from '@sweatpals/shared';
import { LockIcon, Showable } from '@sweatpals/react-ui-kit';
import { getPublicFileUrl } from '@/modules/_core/utils/file.utils';
import { avatarCounterStyles, avatarRow, avatarStyles, lockIconStyles } from './perk-card.styles';

export interface LockedPerksAvatarsProps {
	perks?: ShortCommunityPerkDto[];
}

export const LockedPerksAvatars: FC<LockedPerksAvatarsProps> = props => {
	const { perks } = props;

	return (
		<Box sx={avatarRow}>
			<LockIcon style={lockIconStyles} />
			<AvatarGroup max={3 + 1}>
				{perks?.map(perk => (
					<Avatar key={perk.id} src={getPublicFileUrl(perk.avatarId)} sx={avatarStyles}>
						{perk.id[0]}
					</Avatar>
				))}
				<Showable show={perks && perks?.length - 3 > 0}>
					<Avatar sx={avatarCounterStyles}>+{perks ? perks?.length - 3 : 0}</Avatar>
				</Showable>
			</AvatarGroup>
		</Box>
	);
};
